<template>
  <div class="related-questions" v-if="questions && questions.length > 0">
    <div class="rq-list">
      <button
        v-for="(question, index) in questions"
        :key="index"
        class="rq-item"
        type="button"
        @click="handleClick(question, index)"
      >
        <span class="rq-text">{{ question.title }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "RelatedQuestions",
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(question, index) {
      this.$emit("select", question, index);
    },
  },
};
</script>

<style scoped lang="scss">
.related-questions {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  background: transparent;
}

.rq-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.rq-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 16px;
  border: 1px solid #e6e8ef;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  color: #4a4d55;
  text-align: left;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.2s ease;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rq-item:active {
  transform: translateY(1px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.rq-text {
  line-height: 1.4;
  word-break: break-word;
}
</style>
